import {
  CORPORATE_INFO_URL,
  HELP_CENTER_LINK,
  NEW_CONTACT_REQUEST_URL,
  POLICY_URL,
  USER_TERM_URL,
} from 'common/utils';

interface FooterLinksType {
  className?: string;
}

const FooterLinks = ({ className = '' }: FooterLinksType) => {
  const links = [
    { href: CORPORATE_INFO_URL, label: '会社概要' },
    { href: HELP_CENTER_LINK, label: 'ヘルプ' },
    { href: NEW_CONTACT_REQUEST_URL, label: 'お問い合わせ' },
    { href: USER_TERM_URL, label: '利用規約' },
    {
      href: POLICY_URL,
      label: 'プライバシーポリシー',
    },
  ];

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-2 text-sm ${className}`}
    >
      {links.map((link, index) => (
        <div key={link.href} className="flex items-center">
          <a
            href={link.href}
            target={link.href.startsWith('http') ? '_blank' : '_self'}
            className="px-2 py-1 text-gray-secondary transition-colors duration-200 hover:text-black-primary"
          >
            {link.label}
          </a>
          {index < links.length - 1 && (
            <span className="text-line-secondary">|</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default FooterLinks;
